import { FC } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Swal from 'sweetalert2';
import { OperatorCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import './SCUIAddRoleDialog.scss';
import { SCUIAddRoleDialogContent } from '../SCUIAddRoleDialogContent/SCUIAddRoleDialogContent';

interface IProps {
    open?: boolean;
    onClose?: any;
    refresh?: any;
}
export const SCUIAddRoleDialog: FC<IProps> = ({ open = false, onClose, refresh }) => {
    const { t } = useTranslation();
    const addRole = async (addedRoleItem: any) => {
        if (addedRoleItem.roleNameKey && addedRoleItem.roleNameKey.trim().length > 0) {
            OperatorCommand.PostCreateRole(addedRoleItem)
                .then((res: any) => {
                    if (!res.roleNameKey || res.roleId == 0) {
                        Swal.fire(t('general.couldntAdded'), ' ', 'error');
                        return;
                    }
                    onClose();
                    Swal.fire(t('general.added'), ' ', 'success');
                    refresh();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('authorizationManagement.roleAdd.roleInformation')}</DialogTitle>
            <SCUIAddRoleDialogContent onAddRole={addRole} onCloseAddRole={onClose} />
        </Dialog>
    );
};
